import { render, staticRenderFns } from "./CInformationModal.vue?vue&type=template&id=045de78d&scoped=true&"
import script from "./CInformationModal.vue?vue&type=script&lang=ts&"
export * from "./CInformationModal.vue?vue&type=script&lang=ts&"
import style0 from "./CInformationModal.vue?vue&type=style&index=0&id=045de78d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "045de78d",
  null
  
)

export default component.exports